export default "__VITE_ASSET__CyJsIqRE__"